import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import appcolors from "../../constants/Colors";
import { formattedDate, formattedTime } from "../../utils";
import GlobalButton from "../CustomButton";

export default function DashboardTable({
  headerData,
  tableData,
  diplayRows,
  minWidth,
  showHeader,
  handleViewDetails,
}) {
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    maxHeight: "90vh",
    overflow: "auto",
  };

  return (
    <>
      <TableContainer sx={{ marginTop: "12px" }}>
        <Table
          sx={
            {
              // minWidth: minWidth ? minWidth : 1000,
            }
          }
          size="small"
          stickyHeader
        >
          <TableHead
            sx={{ display: showHeader ? "table-header-group" : "none" }}
          >
            <TableRow>
              {headerData?.map((column, _index) => (
                <TableCell
                  key={_index}
                  align={column.align}
                  style={{
                    minWidth: column.minWidth,
                    color: appcolors.white,
                    fontWeight: "500",
                    fontSize: 14,
                    backgroundColor: appcolors.primary,
                    fontFamily: "Poppins",
                  }}
                >
                  <Typography>{column.label}</Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData
              //   .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              ?.map((row, ind) => {
                console.log(row, "rowrowrowrowrow1221");
                return (
                  <TableRow key={ind}>
                    {diplayRows.map((val) => {
                      return (
                        <React.Fragment key={val}>
                          {val == "dateMonth" ? (
                            <TableCell padding="normal">
                              <Stack>
                                <Typography
                                  variant="h1"
                                  fontSize={"0.875rem"}
                                  fontWeight={600}
                                  color={appcolors.black}
                                >
                                  {moment(row?.services[0]?.startTime).format(
                                    "DD"
                                  )}
                                </Typography>
                                <Typography
                                  variant="body1"
                                  fontSize={"0.75rem"}
                                  color={appcolors.gunmetal}
                                  textTransform={"capitalize"}
                                >
                                  {moment(row?.services[0]?.startTime).format(
                                    "MMM"
                                  )}
                                </Typography>
                              </Stack>
                            </TableCell>
                          ) : val == "ownerData" ? (
                            <TableCell padding="normal">
                              <Stack>
                                <Typography
                                  variant="h1"
                                  fontSize={"0.875rem"}
                                  fontWeight={600}
                                  color={appcolors.black}
                                  textTransform={"capitalize"}
                                >
                                  {row.name}
                                </Typography>
                                <Typography
                                  variant="body1"
                                  fontSize={"0.75rem"}
                                  color={appcolors.gunmetal}
                                >
                                  Email:{row.email}
                                </Typography>
                              </Stack>
                            </TableCell>
                          ) : val == "user_detaile" ? (
                            <TableCell padding="normal">
                              <Stack>
                                <Typography
                                  variant="h1"
                                  fontSize={"0.75rem"}
                                  fontWeight={600}
                                  color={appcolors.black}
                                  textTransform={"capitalize"}
                                >
                                  Name:{row.userName}
                                </Typography>
                                <Typography
                                  variant="body1"
                                  fontSize={"0.75rem"}
                                  color={appcolors.gunmetal}
                                >
                                  Email:{row.userEmail}
                                </Typography>
                              </Stack>
                            </TableCell>
                          ) : val == "assingedBranch" ? (
                            <TableCell padding="normal">
                              <Stack>
                                <Typography
                                  variant="h1"
                                  fontSize={"0.75rem"}
                                  fontWeight={600}
                                  color={appcolors.black}
                                  textTransform={"capitalize"}
                                >
                                  {row.branchName}
                                </Typography>
                              </Stack>
                            </TableCell>
                          ) : val == "appointmentId" ? (
                            <TableCell padding="normal">
                              <Typography
                                variant="body1"
                                fontSize={"0.75rem"}
                                color={appcolors.black}
                              >
                                Appointment#Id
                              </Typography>

                              <Typography
                                variant="h1"
                                fontSize={"0.875rem"}
                                fontWeight={600}
                                color={appcolors.black}
                              >
                                #{row?._id}
                              </Typography>
                            </TableCell>
                          ) : val == "showDetailBtn" ? (
                            <TableCell padding="normal">
                              <Stack
                                direction={"row"}
                                alignItems={"center"}
                                gap={2}
                                sx={{ cursor: "pointer" }}
                              >
                                <Typography
                                  variant="h1"
                                  fontSize={"0.875rem"}
                                  fontWeight={600}
                                  color={appcolors.black}
                                >
                                  Details
                                </Typography>
                                <ArrowRightAltIcon />
                              </Stack>
                            </TableCell>
                          ) : val == "booker_name" ? (
                            <TableCell padding="normal">
                              <Typography
                                variant="h1"
                                fontSize={"0.875rem"}
                                fontWeight={400}
                                color={
                                  row.isDone
                                    ? appcolors.black
                                    : appcolors.slateGrey
                                }
                              >
                                {row.name}
                              </Typography>
                            </TableCell>
                          ) : val == "service" ? (
                            <TableCell padding="normal">
                              <Typography
                                variant="h1"
                                fontSize={"0.875rem"}
                                fontWeight={400}
                                color={
                                  row.isDone
                                    ? appcolors.black
                                    : appcolors.slateGrey
                                }
                              >
                                {row.serviceName}
                              </Typography>
                            </TableCell>
                          ) : val == "totalErnings" ? (
                            <TableCell padding="normal">
                              <Typography
                                variant="h1"
                                fontSize={"0.875rem"}
                                fontWeight={400}
                                color={
                                  row.isDone
                                    ? appcolors.black
                                    : appcolors.slateGrey
                                }
                              >
                                {row.serviceName}
                              </Typography>
                            </TableCell>
                          ) : val == "thisMonth" ? (
                            <TableCell padding="normal">
                              <Typography
                                variant="h1"
                                fontSize={"0.875rem"}
                                fontWeight={400}
                                color={
                                  row.isDone
                                    ? appcolors.black
                                    : appcolors.slateGrey
                                }
                              >
                                {row.serviceCount}
                              </Typography>
                            </TableCell>
                          ) : val == "booked_service" ? (
                            <TableCell padding="normal">
                              <Typography
                                variant="h1"
                                fontSize={"0.875rem"}
                                fontWeight={400}
                                color={
                                  row.isDone
                                    ? appcolors.black
                                    : appcolors.slateGrey
                                }
                              >
                                {row.service}
                              </Typography>
                              <Typography
                                variant="h1"
                                fontSize={"0.875rem"}
                                fontWeight={400}
                                color={
                                  row.isDone
                                    ? appcolors.black
                                    : appcolors.slateGrey
                                }
                              >
                                {formattedDate(row.bookingDate, false)}
                              </Typography>
                            </TableCell>
                          ) : val == "booking_time" ? (
                            <TableCell padding="normal">
                              <Stack
                                gap={1}
                                direction={"row"}
                                alignItems={"center"}
                              >
                                <Stack>
                                  <Typography
                                    variant="h1"
                                    fontSize={"0.875rem"}
                                    fontWeight={400}
                                    color={
                                      row.isDone
                                        ? appcolors.emeraldGreen
                                        : appcolors.indianRed
                                    }
                                  >
                                    {formattedDate(row.createdAt, false)}
                                  </Typography>
                                  <Typography
                                    variant="h1"
                                    fontSize={"0.875rem"}
                                    fontWeight={400}
                                    color={
                                      row.isDone
                                        ? appcolors.emeraldGreen
                                        : appcolors.indianRed
                                    }
                                  >
                                    {formattedTime(row.bookingDate, true)}
                                  </Typography>
                                </Stack>
                                <ArrowRightAltIcon />
                              </Stack>
                            </TableCell>
                          ) : val == "activity_detail" ? (
                            <TableCell padding="normal">
                              <Stack
                                gap={1.5}
                                direction={"row"}
                                alignItems={"center"}
                              >
                                <Typography
                                  variant="body1"
                                  fontSize={"0.75rem"}
                                  color={appcolors.gunmetal}
                                  textTransform={"capitalize"}
                                >
                                  {moment(row.startTime).format(
                                    "DDD, DD/MM/YYYY h:mm a"
                                  )}
                                </Typography>
                                <Typography
                                  variant="body1"
                                  fontSize={"0.75rem"}
                                  color={appcolors.emeraldGreen}
                                  textTransform={"uppercase"}
                                >
                                  {row.status}
                                </Typography>
                              </Stack>
                              <Typography
                                variant="h1"
                                fontSize={"0.875rem"}
                                fontWeight={500}
                              >
                                {row.serviceName}
                              </Typography>
                              <Stack direction={"row"} alignItems={"center"}>
                                <Typography
                                  variant="body1"
                                  fontSize={"0.75rem"}
                                  color={appcolors.gunmetal}
                                  textTransform={"capitalize"}
                                >
                                  Online {row.Duration} with{" "}
                                  {row?.teamMemberName}
                                </Typography>
                              </Stack>
                            </TableCell>
                          ) : val == "appoindment_details" ? (
                            <TableCell padding="normal">
                              <Box>
                                <GlobalButton
                                  variant={"contained"}
                                  handleClickBtn={() =>
                                    handleViewDetails(row?.services)
                                  }
                                  btnText={"View Selected Services"}
                                  styleProps={{
                                    padding: "5px 10px",
                                    width: "auto",
                                    fontWeight: 400,
                                    fontSize: "0.875rem",
                                  }}
                                />
                              </Box>
                            </TableCell>
                          ) : val == "activity_price" ? (
                            <TableCell padding="normal">
                              <Stack
                                gap={1.5}
                                direction={"row"}
                                alignItems={"center"}
                              >
                                <Typography
                                  variant="h1"
                                  fontSize={"0.875rem"}
                                  fontWeight={500}
                                >
                                  {`${row.servicePrice} SAR`}
                                </Typography>
                                <ArrowRightAltIcon />
                              </Stack>
                            </TableCell>
                          ) : val == "serviceName" ? (
                            <TableCell padding="normal">
                              <Stack
                                gap={1.5}
                                direction={"row"}
                                alignItems={"center"}
                              >
                                <Typography
                                  variant="h1"
                                  fontSize={"0.875rem"}
                                  fontWeight={500}
                                >
                                  {row.serviceName}
                                </Typography>
                              </Stack>
                            </TableCell>
                          ) : val == "servicePrice" ? (
                            <TableCell padding="normal">
                              <Stack
                                gap={1.5}
                                direction={"row"}
                                alignItems={"center"}
                              >
                                <Typography
                                  variant="h1"
                                  fontSize={"0.875rem"}
                                  fontWeight={500}
                                >
                                  {`${row.servicePrice} SAR`}
                                </Typography>
                              </Stack>
                            </TableCell>
                          ) : val == "serviceDuration" ? (
                            <TableCell padding="normal">
                              <Stack
                                gap={1.5}
                                direction={"row"}
                                alignItems={"center"}
                              >
                                <Typography
                                  variant="h1"
                                  fontSize={"0.875rem"}
                                  fontWeight={500}
                                >
                                  {row.duration} min
                                </Typography>
                              </Stack>
                            </TableCell>
                          ) : val == "teamMemberName" ? (
                            <TableCell padding="normal">
                              <Stack
                                gap={1.5}
                                direction={"row"}
                                alignItems={"center"}
                              >
                                <Typography
                                  variant="h1"
                                  fontSize={"0.875rem"}
                                  fontWeight={500}
                                >
                                  {row.teamMemberName}
                                </Typography>
                              </Stack>
                            </TableCell>
                          ) : (
                            <TableCell padding="normal">{row[val]}</TableCell>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
